import poissonnerie from './poissonnerie'
import boucherie from './boucherie'

const metiers = { poissonnerie, boucherie }

const PREFIX_TO_METIER = {
  P: 'poissonnerie',
  B: 'boucherie',
}

const DEFAULT_METIER = 'poissonnerie'

export const getMetierFromCode = (code) => {
  if (!code || typeof code !== 'string') return metiers[DEFAULT_METIER]
  const prefix = code.charAt(0).toUpperCase()
  const key = PREFIX_TO_METIER[prefix] || DEFAULT_METIER
  return metiers[key] || metiers[DEFAULT_METIER]
}

export default metiers[DEFAULT_METIER]
